<template>
  <hr :class="[baseCss]" />
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'Divider',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('divider', ['select-none'])
    }
  }
}
</script>
<style>
.bcq-ui-theme-dark .bcq-divider
{
  opacity: .25;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/divider/divider.vue